/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _ActivityState = {
  id: null,
  name: '',
  unit_price: 0,
  sale_unit: ''
}

class ActivityState extends Record(_ActivityState) {
  mergeModel(model) {
    return this.merge(model)
  }
}

export { ActivityState }
